import React, { Fragment } from 'react';
import CONFIG from '../../../config';
import moment from 'moment';
import './styles/index.css';
// import {OfferTimer} from '../../ui/CountDown';
import { OfferText } from '../../ui/SnackBar';
import { TestCaseLoader } from '../../ui/Loader';
import {
  Container,
  StripedContainer,
  Content,
  InnerContainer,
  InfoContent,
  AvailNowButton,
  CloseButton,
  CloseIcon,
  TopInfoBar,
  StripedTopInfoBar,
  TopInfoBarWrapper,
  InfoBarWrapper,
  InfoBarContentWrapper,
  InfoTextWrapper,
  OfferIconWrapper,
  OfferContentOuter,
  OfferBarTimerWrapper,
  InfoBarIconWrapper,
  InfoBarSvg,
  InfoBarTitleText,
  InfoBarText,
  InfoBarLink,
  InfoBarActionButton,
  InfoBarClose,
  InfoBarButton,
  InfoBarLargeText,
  StaticInfoBarOuter,
  StaticInfoBarInner,
  DboardPrimeOfferCardOuter,
  DboardPrimeOfferCardLabel,
  DboardPrimeOfferCardInner,
  DboardPrimeLeftImgWrapper,
  DboardPrimeRightWrapper,
  DboardPrimeOfferCardHead,
  DboardPrimeOfferCardHeadInner,
  PrimeOfferTitleDiv,
  PrimeOfferShineDiv,
  PrimeHeadSpan,
  PrimeOfferTimerDiv,
  DynamicPrimeOfferImgWrapper,
  DynamicPrimeOfferCardBody,
  DboardPrimeOfferSvg,
  DboardPrimeOfferContentWrapper,
  DboardPrimeOfferButton,
} from './styles';
import { PrimeOffer } from '../../ui/SnackBar';
import InfoBarConfetti from '../../ui/CanvasConfetti/InfoBarConfetti';
import { RxLapTimer } from 'react-icons/rx';

/** To calculate the promo expiring date  **/
const currentDate = new Date().getDate();
let expiringDate, formattedExpireDate;

if (currentDate % 2 === 0) {
  expiringDate = new Date().setDate(currentDate + 1);
} else {
  expiringDate = new Date().setDate(currentDate);
}

formattedExpireDate = moment(expiringDate).format('Do MMM YYYY');

/*---  offer page links starts (reused below recheck before changing) ---*/
const originalsOfferLinkPrefix = '/lb-spl-off-18fdd2ad71d';
const partnerOfferLinkPrefix = '/partner-plus-sale';
const dataAnalysisOfferLinkPrefix = '/ptnr-daly-nrc-1933f19ac85';
const juniorsOfferLinkPrefix = '/code-juniors-sale';

// non recurrent
const nonRecurrentOriginalsOfferPrefix = '/lb-nrc-190fd6c18ec';
const nonRecurrentPartnersOfferPrefix = '/ptnr-nrc-190fd6d394d';
const nonRecurrentJuniorsOfferPrefix = `/jnrs-nrc-1932529a0f1`;
/* --- offer page links ends ---*/

const StudentOfferInfo = ({ history, handleInfoBar }) => (
  <Container>
    <Content>
      <span>
        Students can get 30% OFF on <strong>Log2Base2 Student Offer</strong> scheme. [Limited Number of Students Only]
      </span>
      <AvailNowButton onClick={() => history.push('/students')}>Get now</AvailNowButton>
      <CloseButton onClick={handleInfoBar}>Close</CloseButton>
    </Content>
  </Container>
);

const NewCourseLaunchInfo = ({ history, handleInfoBar }) => (
  <Container>
    <Content>
      <span>
        New Course Update! Enjoy the <strong>Problem Solving for Beginners</strong> course with an introductory offer.
      </span>
      <AvailNowButton
        onClick={() => {
          history.push('/problem-solving-beginners');
        }}
      >
        Learn More
      </AvailNowButton>
      <CloseButton onClick={handleInfoBar}>Close</CloseButton>
    </Content>
  </Container>
);

const PromoCodeInfo = ({ isOnlyForAbroad, handleInfoBar, checkout, handlePromocodePricing, country, status, handleAllAccessClick, loading, infoBarMessage, differentCostPath }) => (
  <Container checkout={checkout}>
    {isOnlyForAbroad ? (
      <InnerContainer>
        <InfoContent>
          <OfferText>
            {infoBarMessage} <span className="fs-18 weight-700">$59.99</span> <del>$99.99</del>
            <span className="fs-14">
              {' '}
              / year. <span className="fs-14">(Limited Time Offer)</span>
            </span>
          </OfferText>
          <AvailNowButton onClick={handleAllAccessClick}>Get now {loading && <TestCaseLoader />} </AvailNowButton>
        </InfoContent>
        <CloseIcon onClick={handleInfoBar} />
      </InnerContainer>
    ) : (
      <InnerContainer>
        <InfoContent>
          {/* | <OfferText>Placement season is here!</OfferText> Use promo code <AvailNowButton style={{minWidth: '100px', left: 0, padding: '2px', cursor: 'default'}}>PLACEMENT</AvailNowButton> and get 20% OFF on any course
				    <CloseIcon onClick={handleInfoBar}>Close</CloseIcon> */}
          <OfferText>
            {infoBarMessage} {country !== 'IN' ? (differentCostPath ? '$14.99' : '$9.99') : !differentCostPath ? '₹499' : '₹999'} <span className="fs-14">/ year.</span>
          </OfferText>
          {/* <OfferText>Summer Offer | </OfferText>Use promo code <AvailNowButton style={{minWidth: '90px', left: 0, padding: '4px 10px', cursor: 'default', letterSpacing: '0.9px', borderRadius: '13px', background: '#f4c510'}}>SUM50</AvailNowButton> and get 50% on all courses. */}
          {(status || handlePromocodePricing) && <AvailNowButton onClick={handleAllAccessClick}>Get now {loading && <TestCaseLoader />} </AvailNowButton>}
          {/* <span className="weight-600" style={{color: '#ffe05d'}}>Offer Ends Today!</span> */}
        </InfoContent>
        <CloseIcon onClick={handleInfoBar} />
      </InnerContainer>
    )}
  </Container>
);

const CourseOfferInfo = ({ handleInfoBar, courseName, specialPrice, handleCourseAccess, isFromDSA }) => (
  <TopInfoBar closeIcon>
    <TopInfoBarWrapper>
      <OfferIconWrapper>
        <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>Offer Icon</InfoBarSvg>
        <PrimeOffer isNoMargin={true} noMarginTop={true} minimalGap={true} />
      </OfferIconWrapper>
      <InfoBarText>
        Special offer | Get the <span className="weight-600">{courseName}</span> {!isFromDSA && 'course'} at just{' '}
        <del className="ml-1" style={{ color: 'var(--gray)' }}>
          {specialPrice && specialPrice.currencySymbol}
          {specialPrice && specialPrice.listPrice}
        </del>
        <span className="no-text-wrap ml-2">
          <span className="weight-600">
            {specialPrice && specialPrice.currencySymbol}
            {specialPrice && specialPrice.offerPrice}
          </span>
          <span className="responsiveTxt"> / year</span>
        </span>{' '}
        <InfoBarLink onClick={() => handleCourseAccess(specialPrice)}>Buy now ➜</InfoBarLink>
      </InfoBarText>
      <div className="d-md-inline-block">
        <InfoBarButton onClick={() => handleCourseAccess(specialPrice)}>Buy now</InfoBarButton>
      </div>
    </TopInfoBarWrapper>
    <InfoBarClose onClick={handleInfoBar} />
  </TopInfoBar>
);

const CountrySpecificPricingInfo = ({ handleInfoBar, trialSnackbar, countryName, headerOfferLink }) => (
  <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
    <TopInfoBarWrapper>
      <OfferIconWrapper>
        <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>Offer Icon</InfoBarSvg>
        <PrimeOffer isNoMargin={true} noMarginTop={true} minimalGap={true} />
      </OfferIconWrapper>
      <InfoBarText>
        Special Offer for <span className="no-text-wrap weight-600">{countryName}</span>{' '}
        <span>
          | Get <span className="weight-600">20%</span> Off
        </span>{' '}
        on Log2Base2 Prime Membership. <InfoBarLink onClick={() => (window.location.href = headerOfferLink)}>Get now ➜</InfoBarLink>
      </InfoBarText>
      <div className="d-md-inline-block">
        <InfoBarButton onClick={() => (window.location.href = headerOfferLink)}>Get now</InfoBarButton>
      </div>
    </TopInfoBarWrapper>
    <InfoBarClose onClick={handleInfoBar} />
  </TopInfoBar>
);

const OneTimeOffer = ({ country, headerOfferLink }) => (
  <TopInfoBar oneTimeOffer>
    <OfferContentOuter>
      <OfferBarTimerWrapper oneTimeOffer>
        {/*<div className="d-flex align-items-center justify-content-center pb-1 d-md-none">
          <span className="darkTxt headingFont fs-14 weight-600">Hurry up! Big Diwali Sale</span>
        </div>*/}
        {/* {country === 'IN' && <img width="32px" height="32px" src="/Assets/Velakku.png" className="d-none d-md-block mr-1" />} */}
        <PrimeOffer isNoMargin={true} noMarginTop={true} noLineHeight={true} minimalGap={true} minimalOffer={true} />
      </OfferBarTimerWrapper>
      <InfoBarText oneTimeOffer>
        <span className="text-inheritance d-sm-none">
          <span className="darkTxt headingFont weight-600 no-text-wrap mr-1 d-sm-none">Great Republic Day Sale Ending Soon</span> - Use code{' '}
          <span className="weight-600">{headerOfferLink}</span> before{' '}
          <span className="no-text-wrap">
            31<sup>st</sup> Jan, 11:59 PM,
          </span>{' '}
          to enjoy <span className="weight-600">45%</span> Off.
        </span>
        <span className="text-inheritance d-none d-sm-inline">
          <span className="d-none d-sm-inline weight-600">
            {/* {country === 'IN' && <img src="/Assets/Velakku.png" className="mr-1" style={{ width: '18px', transform: 'translateY(-3px)' }} />} */}
            Hurry! Great Republic Day Sale Ending Soon
          </span>{' '}
          - Use code <span className="weight-600">{headerOfferLink}</span> before{' '}
          <span className="no-text-wrap">
            31<sup>st</sup> Jan, 11:59 PM,
          </span>{' '}
          to enjoy <span className="weight-600">45%</span> Off.{' '}
          {/* {country === 'IN' && <img src="/Assets/Velakku.png" className="ml-1" style={{ width: '18px', transform: 'translateY(-3px)' }} />} */}
        </span>
      </InfoBarText>
    </OfferContentOuter>
  </TopInfoBar>
);

const SpecialOfferBar = ({ country, trialSnackbar, handleInfoBar, headerOfferDayCount }) => (
  <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
    <OfferContentOuter style={{ justifyContent: 'unset' }}>
      <OfferBarTimerWrapper oneTimeOffer>
        <PrimeOffer isNoMargin={true} noMarginTop={true} noLineHeight={true} minimalGap={true} minimalOffer={true} numDays={headerOfferDayCount} />
      </OfferBarTimerWrapper>
      <InfoBarText oneTimeOffer>
        <span className="headingFont weight-600">Limited Time Offer: </span>
        <span className="headingFont">
          Get massive <span className="weight-600">66%</span> discounts on{' '}
          <a className="underlinedLink darkTxt" href="/special-offer-courses">
            individual courses
          </a>
          , and{' '}
          <a className="underlinedLink darkTxt" href="/special-offer-packages">
            packages
          </a>
          .
        </span>
      </InfoBarText>
    </OfferContentOuter>
    <InfoBarClose onClick={handleInfoBar} />
  </TopInfoBar>
);

const StaticInfo = ({ content }) => (
  <StaticInfoBarOuter>
    <StaticInfoBarInner>
      <OfferBarTimerWrapper style={{ padding: '4px 0px' }}>
        <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'} style={{ marginRight: '8px' }}>
          OfferIcon
        </InfoBarSvg>
        <PrimeOffer isNoMargin={true} noMarginTop={true} noLineHeight={true} minimalGap={true} minimalOffer={true} />
      </OfferBarTimerWrapper>
      {content === 'special-off-66' ? (
        <span className="headingFont weight-500">
          🔥 Unlock Massive Savings with a Spectacular <span className="headingFont weight-600">66% Discount!</span> Hurry, This Offer Won't Last Forever 🔥
        </span>
      ) : content === 'prime-30' ? (
        <span className="headingFont weight-500">
          <span className="headingFont weight-600">Limited-time Offer:</span> Use code <span className="headingFont weight-600">PRIME30</span> at checkout to enjoy{' '}
          <span className="headingFont weight-600">30% Off</span> on Prime Membership.
        </span>
      ) : content === 'special-off-30' ? (
        <span className="headingFont weight-500">
          <span className="headingFont weight-600">Special Offer:</span> Enter promo code <span className="headingFont weight-600">SPL30</span> at checkout for{' '}
          <span className="headingFont weight-600">30% Off</span> individual courses and packages.
        </span>
      ) : null}
    </StaticInfoBarInner>
  </StaticInfoBarOuter>
);

const ConfettiInfo = ({
  content,
  variant,
  darkTheme,
  handleInfoBar,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  language,
  coursesLanguage,
  offerPrice,
  headerOfferDayCount,
  headerOfferImg,
}) => {
  let navigateLink, partnerNavigateLink;
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    partnerNavigateLink = `${partnerOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    partnerNavigateLink = partnerOfferLinkPrefix;
  }
  let regionalsNavigateLink = `/regionals-${language}-sale/?user_target_offer=${headerOfferLink}`;
  let regionalsAnimationNavigateLink = `/${language}-animation-sale/?user_target_offer=${headerOfferLink}`;
  let regionalsExpertNavigateLink = `/${language}-expert-sale/?user_target_offer=${headerOfferLink}`;
  let juniorsNavigateLink = `/code-juniors-sale/?user_target_offer=${headerOfferLink}`;

  return (
    <StaticInfoBarOuter variant={variant} darkTheme={darkTheme}>
      <StaticInfoBarInner variant={variant} darkTheme={darkTheme} style={{ justifyContent: 'unset' }}>
        <OfferBarTimerWrapper style={{ padding: '4px 0px' }}>
          {headerOfferImg ? (
            <img className="dynamic-offer-img-large" src={headerOfferImg} />
          ) : (
            <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'} style={{ marginRight: '8px' }}>
              OfferIcon
            </InfoBarSvg>
          )}
          <PrimeOffer
            isNoMargin={true}
            noMarginTop={true}
            noLineHeight={true}
            minimalGap={true}
            minimalOffer={true}
            numDays={headerOfferDayCount}
            light={darkTheme || variant === 'regionals' || variant === 'partner-plus' || variant === 'code-juniors'}
          />
        </OfferBarTimerWrapper>

        {content === 'originals-prime' ? (
          <div>
            <span className="text-inheritance">
              {headerOfferPath ? (
                <Fragment>
                  <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                  <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                </Fragment>
              ) : (
                <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
              )}
            </span>
            <a className="text-nowrap headingFont weight-600 underlinedLink ml-1" href={navigateLink} style={{ color: darkTheme ? '#fff' : 'var(--inputTxtColor)' }}>
              Buy now ➜
            </a>
          </div>
        ) : null}

        {content === 'partner-prime' ? (
          <div>
            <span className="text-inheritance">
              {headerOfferPath ? (
                <Fragment>
                  <span className="d-lg-none dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                  <span className="d-none d-lg-inline dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                </Fragment>
              ) : (
                <span className="dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
              )}
            </span>
            <a className="text-white text-nowrap headingFont weight-600 underlinedLink ml-1" href={partnerNavigateLink}>
              Buy now ➜
            </a>
          </div>
        ) : null}

        {content === 'regionals-prime' ? (
          <div>
            <span className="text-inheritance">
              {headerOfferPath ? (
                <Fragment>
                  <span className="d-lg-none dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                  <span className="d-none d-lg-inline dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                </Fragment>
              ) : (
                <span className="dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
              )}
            </span>
            <a className="text-white text-nowrap headingFont weight-600 underlinedLink ml-1" href={regionalsNavigateLink}>
              Buy now ➜
            </a>
          </div>
        ) : null}

        {content === 'regionals-animation' ? (
          <div>
            <span className="text-inheritance">
              {headerOfferPath ? (
                <Fragment>
                  <span className="d-lg-none dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                  <span className="d-none d-lg-inline dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                </Fragment>
              ) : (
                <span className="dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
              )}
            </span>
            <a className="text-white text-nowrap headingFont weight-600 underlinedLink ml-1" href={regionalsAnimationNavigateLink}>
              Buy now ➜
            </a>
          </div>
        ) : null}

        {content === 'regionals-expert' ? (
          <div>
            <span className="text-inheritance">
              {headerOfferPath ? (
                <Fragment>
                  <span className="d-lg-none dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                  <span className="d-none d-lg-inline dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                </Fragment>
              ) : (
                <span className="dynamic-offer-yellow-highlight" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
              )}
            </span>
            <a className="text-white text-nowrap headingFont weight-600 underlinedLink ml-1" href={regionalsExpertNavigateLink}>
              Buy now ➜
            </a>
          </div>
        ) : null}

        {content === 'juniors-prime' ? (
          <div>
            <span className="text-inheritance">
              {headerOfferPath ? (
                <Fragment>
                  <span className="d-lg-none dynamic-offer-yellow-color" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                  <span className="d-none d-lg-inline dynamic-offer-yellow-color" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                </Fragment>
              ) : (
                <span className="dynamic-offer-yellow-color" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
              )}
            </span>
            <a className="text-white text-nowrap headingFont weight-600 underlinedLink ml-1" href={juniorsNavigateLink}>
              Buy now ➜
            </a>
          </div>
        ) : null}
      </StaticInfoBarInner>
      <InfoBarConfetti />
    </StaticInfoBarOuter>
  );
};

const ConfettiHeaderBar = ({ content, handleInfoBar, trialSnackbar }) => {
  let navigateLink = originalsOfferLinkPrefix;
  return (
    <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
      <InfoBarContentWrapper onClick={() => (window.location.href = navigateLink)}>
        <OfferBarTimerWrapper>
          <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>

          <PrimeOffer isNoMargin={true} noMarginTop={true} noLineHeight={true} minimalGap={true} minimalOffer={true} />
        </OfferBarTimerWrapper>

        {content === 'originals-prime' ? (
          <InfoBarText oneTimeOffer>
            <span className="darkTxt headingFont weight-500">
              <span className="headingFont weight-600">Limited-time Offer:</span> Get <span className="headingFont weight-600">30%</span> special discount on prime membership.
            </span>
            <span className="text-nowrap headingFont weight-500 underlinedLink darkTxt ml-2">Get it now!</span>
          </InfoBarText>
        ) : null}
        <InfoBarConfetti />
      </InfoBarContentWrapper>
      <InfoBarClose onClick={handleInfoBar} />
    </TopInfoBar>
  );
};

const OriginalsTopOfferBar = ({
  country,
  handleInfoBar,
  trialSnackbar,
  headerOfferName,
  headerOfferPercent,
  headerOfferPath,
  headerOfferLink,
  headerOfferDayCount,
  headerOfferEndTime,
  headerOfferImg,
  headerOfferTitle,
  nonRecurrentBar,
}) => {
  let navigateLink, promoLink;
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    promoLink = `${nonRecurrentOriginalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    promoLink = nonRecurrentOriginalsOfferPrefix;
  }

  return (
    <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
      <InfoBarContentWrapper
        onClick={() => {
          if (nonRecurrentBar) window.location.href = promoLink;
          else window.location.href = navigateLink;
        }}
      >
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </TopInfoBar>
  );
};

const OriginalsBottomOfferBar = ({
  handleInfoBar,
  headerOfferLink,
  headerOfferName,
  headerOfferPath,
  headerOfferTitle,
  headerOfferPercent,
  headerOfferImg,
  headerOfferDayCount,
  headerOfferEndTime,
  nonRecurrentBar,
}) => {
  let navigateLink, promoLink;
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    promoLink = `${nonRecurrentOriginalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    promoLink = nonRecurrentOriginalsOfferPrefix;
  }

  return (
    <Container>
      {/*<InfoBarWrapper closeIcon={true}>
          <InfoBarSvg data={CONFIG.cloudFront + '/Assets/giftBox.svg'}>giftBox</InfoBarSvg>
          <InfoBarText>
            Year End Sale | <span className="goldenTxt">Get 20% Off</span> <span className="d-none d-md-inline-block">on Log2Base2 Prime Membership</span>
          </InfoBarText>
          <InfoBarActionButton href="/pricing">Buy now</InfoBarActionButton>

          <InfoBarClose onClick={handleInfoBar} />
          <InfoBarConfetti />
        </InfoBarWrapper>*/}

      <InfoBarContentWrapper
        onClick={() => {
          if (nonRecurrentBar) window.location.href = promoLink;
          else window.location.href = navigateLink;
        }}
      >
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </Container>
  );
};

const RegionalsOfferInfo = ({
  country,
  trialSnackbar,
  handleInfoBar,
  language,
  coursesLanguage,
  courseCategory,
  offerPrice,
  oldPrice,
  courseName,
  specialPrice,
  handleCourseAccess,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  headerOfferDayCount,
  headerOfferImg,
  headerOfferEndTime,
  headerOfferTitle,
  headerOfferPercent,
  nonRecurrentBar,
}) => {
  let nonRecurrentRegionalsOfferPrefix = `/rgnl-${language}-nrc-193252a70f6`;
  let navigateLink, promoLink;
  // if (headerOfferLink && headerOfferLink !== '') {
  //   navigateLink = `/regionals-${language}-sale/?user_target_offer=${headerOfferLink}`;
  //   promoLink = `${nonRecurrentRegionalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  // } else {
  //   navigateLink = `/regionals-${language}-sale`;
  //   promoLink = nonRecurrentRegionalsOfferPrefix;
  // }
  if (courseCategory === 'professional') {
    if (headerOfferLink && headerOfferLink !== '') {
      navigateLink = `/${language}-expert-sale/?user_target_offer=${headerOfferLink}`;
      promoLink = `/rgnl-${language}-exp-nrc-1933f54b282/?user_target_offer=${headerOfferLink}`;
    } else {
      navigateLink = `/${language}-expert-sale`;
      promoLink = `/rgnl-${language}-exp-nrc-1933f54b282`;
    }
  } else {
    if (headerOfferLink && headerOfferLink !== '') {
      navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
      promoLink = `${nonRecurrentOriginalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
    } else {
      navigateLink = originalsOfferLinkPrefix;
      promoLink = nonRecurrentOriginalsOfferPrefix;
    }
  }

  return (
    <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
      <TopInfoBarWrapper
        onClick={() => {
          // if (nonRecurrentBar) window.location.href = promoLink;
          // else
          window.location.href = navigateLink;
        }}
      >
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
        {/*<InfoBarText>
            <InfoBarLargeText>Limited Time Offer</InfoBarLargeText>| Get all <span className="weight-600">{courseName}</span> courses at{' '}
            <del className="ml-1" style={{ color: 'var(--gray)' }}>
              {specialPrice && specialPrice.currencySymbol}
              {specialPrice && specialPrice.listPrice}
            </del>
            <span className="no-text-wrap ml-2">
              <span className="weight-600">
                {specialPrice && specialPrice.currencySymbol}
                {specialPrice && specialPrice.offerPrice}
              </span>
              <span className="responsiveTxt"> / year</span>
            </span>{' '}    
            <InfoBarLink onClick={() => handleCourseAccess(specialPrice)}>Buy now ➜</InfoBarLink>
          </InfoBarText>*/}
        {/*<div className="d-md-inline-block">
            <InfoBarButton onClick={() => handleCourseAccess(specialPrice)}>Buy now</InfoBarButton>
          </div>*/}
      </TopInfoBarWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </TopInfoBar>
  );
};

const RegionalsBottomOffer = ({
  country,
  handleInfoBar,
  language,
  coursesLanguage,
  offerPrice,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  headerOfferDayCount,
  headerOfferImg,
  headerOfferEndTime,
  headerOfferTitle,
  headerOfferPercent,
  nonRecurrentBar,
}) => {
  let nonRecurrentRegionalsOfferPrefix = `/rgnl-${language}-nrc-193252a70f6`;
  let navigateLink, promoLink;
  // if (headerOfferLink && headerOfferLink !== '') {
  //   navigateLink = `/regionals-${language}-sale/?user_target_offer=${headerOfferLink}`;
  //   promoLink = `${nonRecurrentRegionalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  // } else {
  //   navigateLink = `/regionals-${language}-sale`;
  //   promoLink = nonRecurrentRegionalsOfferPrefix;
  // }
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    promoLink = `${nonRecurrentOriginalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    promoLink = nonRecurrentOriginalsOfferPrefix;
  }

  return (
    <Container>
      <InfoBarContentWrapper
        onClick={() => {
          // if (nonRecurrentBar) window.location.href = promoLink;
          // else
          window.location.href = navigateLink;
        }}
      >
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </Container>
  );
};

const PartnerPlusOffer = ({
  handleInfoBar,
  trialSnackbar,
  nonRecurrentBar,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  headerOfferDayCount,
  headerOfferImg,
  headerOfferPercent,
  headerOfferEndTime,
  headerOfferTitle,
}) => {
  // let navigateLink = `${partnerOfferLinkPrefix}${partnerOfferLinkSuffix}`;
  // let promoLink = `${nonRecurrentPartnersOfferPrefix}${partnerOfferLinkSuffix}`;
  let navigateLink, promoLink;
  // if (headerOfferLink && headerOfferLink !== '') {
  //   navigateLink = `${partnerOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  //   promoLink = `${nonRecurrentPartnersOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  // } else {
  //   navigateLink = partnerOfferLinkPrefix;
  //   promoLink = nonRecurrentPartnersOfferPrefix;
  // }
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    promoLink = `${nonRecurrentOriginalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    promoLink = nonRecurrentOriginalsOfferPrefix;
  }

  return (
    <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
      <InfoBarContentWrapper
        onClick={() => {
          // if (nonRecurrentBar) window.location.href = promoLink;
          // else
          window.location.href = navigateLink;
        }}
      >
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </TopInfoBar>
  );
};

const PartnerPlusBottomOffer = ({
  handleInfoBar,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  headerOfferDayCount,
  headerOfferImg,
  headerOfferEndTime,
  headerOfferTitle,
  headerOfferPercent,
  nonRecurrentBar,
}) => {
  // let navigateLink = `${partnerOfferLinkPrefix}${partnerOfferLinkSuffix}`;
  let navigateLink, promoLink;
  // if (headerOfferLink && headerOfferLink !== '') {
  //   navigateLink = `${partnerOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  //   promoLink = `${nonRecurrentPartnersOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  // } else {
  //   navigateLink = partnerOfferLinkPrefix;
  //   promoLink = nonRecurrentPartnersOfferPrefix;
  // }
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    promoLink = `${nonRecurrentOriginalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    promoLink = nonRecurrentOriginalsOfferPrefix;
  }

  return (
    <Container>
      <InfoBarContentWrapper
        onClick={() => {
          // if (nonRecurrentBar) window.location.href = promoLink;
          // else
          window.location.href = navigateLink;
        }}
      >
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </Container>
  );
};

const PackageOffer = ({
  handleInfoBar,
  trialSnackbar,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  packageOfferLinkPrefix,
  country,
  courseName,
  offerPrice,
  oldPrice,
  headerOfferDayCount,
  headerOfferImg,
  headerOfferEndTime,
  headerOfferTitle,
  headerOfferPercent,
}) => {
  let navigateLink;
  // if (headerOfferLink && headerOfferLink !== '') {
  //   navigateLink = `${packageOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  // } else {
  //   navigateLink = packageOfferLinkPrefix;
  // }
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
  }

  return (
    <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
      <InfoBarContentWrapper onClick={() => (window.location.href = navigateLink)}>
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </TopInfoBar>
  );
};

const RegionalPackageOffer = ({
  handleInfoBar,
  trialSnackbar,
  packageOfferLinkPrefix,
  country,
  language,
  coursesLanguage,
  courseName,
  offerPrice,
  oldPrice,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  headerOfferDayCount,
  headerOfferImg,
  headerOfferEndTime,
  headerOfferTitle,
  headerOfferPercent,
}) => {
  let navigateLink;
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${packageOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = packageOfferLinkPrefix;
  }

  return (
    <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
      <InfoBarContentWrapper onClick={() => (window.location.href = navigateLink)}>
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </TopInfoBar>
  );
};

const CodeJuniorsOffer = ({
  handleInfoBar,
  trialSnackbar,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  headerOfferDayCount,
  headerOfferImg,
  headerOfferEndTime,
  headerOfferTitle,
  headerOfferPercent,
  nonRecurrentBar,
}) => {
  let navigateLink, promoLink;
  // if (headerOfferLink && headerOfferLink !== '') {
  //   navigateLink = `${juniorsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  //   promoLink = `${nonRecurrentJuniorsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  // } else {
  //   navigateLink = juniorsOfferLinkPrefix;
  //   promoLink = nonRecurrentJuniorsOfferPrefix;
  // }
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    promoLink = `${nonRecurrentOriginalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    promoLink = nonRecurrentOriginalsOfferPrefix;
  }

  return (
    <TopInfoBar trialSnackbar={trialSnackbar} closeIcon>
      <InfoBarContentWrapper
        onClick={() => {
          // if (nonRecurrentBar) window.location.href = promoLink;
          // else
          window.location.href = navigateLink;
        }}
      >
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </TopInfoBar>
  );
};

const CodeJuniorsBottomOffer = ({
  handleInfoBar,
  headerOfferName,
  headerOfferPath,
  headerOfferLink,
  headerOfferDayCount,
  headerOfferImg,
  headerOfferEndTime,
  headerOfferTitle,
  headerOfferPercent,
  nonRecurrentBar,
}) => {
  let navigateLink, promoLink;
  // if (headerOfferLink && headerOfferLink !== '') {
  //   navigateLink = `${juniorsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  //   promoLink = `${nonRecurrentJuniorsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  // } else {
  //   navigateLink = juniorsOfferLinkPrefix;
  //   promoLink = nonRecurrentJuniorsOfferPrefix;
  // }
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    promoLink = `${nonRecurrentOriginalsOfferPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    promoLink = nonRecurrentOriginalsOfferPrefix;
  }

  return (
    <Container>
      <InfoBarContentWrapper
        onClick={() => {
          // if (nonRecurrentBar) window.location.href = promoLink;
          // else
          window.location.href = navigateLink;
        }}
      >
        <div className="d-none d-lg-flex align-items-lg-center">
          <InfoBarIconWrapper>
            {headerOfferImg ? (
              <img className="dynamic-offer-img-large" src={headerOfferImg} />
            ) : (
              <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
            )}
          </InfoBarIconWrapper>

          <span className="d-block">
            {headerOfferPercent && <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>}{' '}
            <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <InfoTextWrapper>
            <span className="d-block d-lg-none">
              <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferTitle }}></InfoBarTitleText>
              {headerOfferPercent && (
                <Fragment>
                  {' '}
                  - <InfoBarTitleText dangerouslySetInnerHTML={{ __html: headerOfferPercent }}></InfoBarTitleText>
                </Fragment>
              )}
            </span>

            <InfoBarText oneTimeOffer>
              <span className="text-inheritance">
                {headerOfferPath ? (
                  <Fragment>
                    <span className="d-lg-none" dangerouslySetInnerHTML={{ __html: headerOfferPath }}></span>
                    <span className="d-none d-lg-inline" dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                  </Fragment>
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: headerOfferName }}></span>
                )}{' '}
                <span className="d-lg-none">
                  <InfoBarLink>Buy now ➜</InfoBarLink>
                </span>
              </span>
            </InfoBarText>
          </InfoTextWrapper>
        </div>

        <div className="d-none d-lg-block">
          <OfferBarTimerWrapper>
            <PrimeOffer
              type={'header-prime-bar'}
              isNoMargin={true}
              noMarginTop={true}
              noLineHeight={true}
              minimalGap={true}
              minimalOffer={true}
              numDays={headerOfferDayCount}
              offerEndTime={headerOfferEndTime}
            />
          </OfferBarTimerWrapper>
        </div>

        <div className="flexBoxOnLargeMobile align-items-center justify-content-center pt-1 pt-lg-0">
          <div className="d-none d-md-block d-lg-none">
            <InfoBarIconWrapper>
              {headerOfferImg ? (
                <img className="dynamic-offer-img-large" src={headerOfferImg} />
              ) : (
                <InfoBarSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>OfferIcon</InfoBarSvg>
              )}
            </InfoBarIconWrapper>
          </div>
          <div className="d-lg-none">
            <OfferBarTimerWrapper>
              <PrimeOffer
                type={'header-prime-bar'}
                isNoMargin={true}
                noMarginTop={true}
                noLineHeight={true}
                minimalGap={true}
                minimalOffer={true}
                numDays={headerOfferDayCount}
                offerEndTime={headerOfferEndTime}
              />
            </OfferBarTimerWrapper>
          </div>
          <div className="d-none d-lg-block">
            <InfoBarButton>Buy now ➜</InfoBarButton>
          </div>
        </div>
      </InfoBarContentWrapper>
      <InfoBarConfetti />
      <InfoBarClose onClick={handleInfoBar} />
    </Container>
  );
};

/* Dashboard offer bar */
const DboardDynamicPrimeBar = ({
  variant,
  darkTheme,
  content,
  history,
  language,
  coursesLanguage,
  courseCategory,
  headerOfferLink,
  headerOfferDayCount,
  headerBannerImg,
  headerOfferTitle,
  headerOfferDescription,
  headerOfferPercentage,
  headerOfferEndTime,
}) => {
  let navigateLink, partnerNavigateLink;
  if (headerOfferLink && headerOfferLink !== '') {
    navigateLink = `${originalsOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
    partnerNavigateLink = `${partnerOfferLinkPrefix}/?user_target_offer=${headerOfferLink}`;
  } else {
    navigateLink = originalsOfferLinkPrefix;
    partnerNavigateLink = partnerOfferLinkPrefix;
  }
  let regionalsNavigateLink = `/regionals-${language}-sale/?user_target_offer=${headerOfferLink}`;
  let regionalsAnimationNavigateLink = `/${language}-animation-sale/?user_target_offer=${headerOfferLink}`;
  let regionalsExpertNavigateLink = `/${language}-expert-sale/?user_target_offer=${headerOfferLink}`;
  let juniorsNavigateLink = `/code-juniors-sale/?user_target_offer=${headerOfferLink}`;
  let partnerPackageNavigateLink = `/${language}-sale/?user_target_offer=${headerOfferLink}`;

  const _renderContent = () => {
    return (
      <Fragment>
        <DboardPrimeLeftImgWrapper isDynamic={headerBannerImg ? 'true' : 'false'}>
          {headerBannerImg ? (
            <DynamicPrimeOfferImgWrapper isDynamic={'true'}>
              <img className="w-100 dynamic-offer-card-img-radius" src={CONFIG.cloudFront + headerBannerImg} alt="" />
            </DynamicPrimeOfferImgWrapper>
          ) : (
            <DynamicPrimeOfferImgWrapper isDynamic={'false'}>
              {variant === 'originals' ? (
                <DboardPrimeOfferSvg data={CONFIG.cloudFront + '/Assets/GiftBurst.svg'}>offer Icon</DboardPrimeOfferSvg>
              ) : (
                <DboardPrimeOfferSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>offer Icon</DboardPrimeOfferSvg>
              )}
            </DynamicPrimeOfferImgWrapper>
          )}

          <div className="d-none d-sm-block d-md-none pt-3">
            <PrimeOfferTitleDiv style={{ padding: 'unset' }}>
              <PrimeHeadSpan variant={variant === 'regionals' ? 'light' : ''}>
                <span
                  className={`${variant === 'code-juniors' ? 'dynamic-offer-yellow-color' : 'dynamic-offer-yellow-highlight'} font-size-inherit headingFont weight-600`}
                  dangerouslySetInnerHTML={{ __html: headerOfferTitle }}
                ></span>
              </PrimeHeadSpan>
            </PrimeOfferTitleDiv>
          </div>
        </DboardPrimeLeftImgWrapper>

        <DboardPrimeRightWrapper variant={variant}>
          <DboardPrimeOfferCardHead variant={variant}>
            <DboardPrimeOfferCardHeadInner>
              <div className="d-sm-none d-md-flex">
                <PrimeOfferTitleDiv>
                  <PrimeHeadSpan variant={variant === 'regionals' ? 'light' : ''}>
                    <span
                      className={`${variant === 'code-juniors' ? 'dynamic-offer-yellow-color' : 'dynamic-offer-yellow-highlight'} font-size-inherit headingFont weight-600`}
                      dangerouslySetInnerHTML={{ __html: headerOfferTitle }}
                    ></span>
                  </PrimeHeadSpan>
                </PrimeOfferTitleDiv>
              </div>

              {headerOfferPercentage ? (
                <PrimeOfferTitleDiv>
                  <PrimeOfferShineDiv variant={variant === 'regionals' ? 'light' : ''}>
                    <span
                      className={`${
                        variant === 'code-juniors' ? 'dynamic-offer-yellow-color' : 'dynamic-offer-yellow-highlight'
                      } position-relative font-size-inherit headingFont weight-600`}
                      dangerouslySetInnerHTML={{ __html: headerOfferPercentage }}
                    ></span>
                  </PrimeOfferShineDiv>
                </PrimeOfferTitleDiv>
              ) : null}

              <div className="d-none d-xl-flex align-items-center">
                <PrimeOfferTimerDiv>
                  <PrimeOffer
                    type={'dboard-prime-bar'}
                    variant={variant}
                    isNoMargin={true}
                    noMarginTop={true}
                    minimalGap={true}
                    numDays={headerOfferDayCount}
                    offerEndTime={headerOfferEndTime}
                  />
                </PrimeOfferTimerDiv>
              </div>
            </DboardPrimeOfferCardHeadInner>
          </DboardPrimeOfferCardHead>
          <DynamicPrimeOfferCardBody isDynamic={headerBannerImg ? 'true' : 'false'}>
            <div className="d-sm-none">
              {headerBannerImg ? (
                <DynamicPrimeOfferImgWrapper isDynamic={'true'}>
                  <img className="w-100 dynamic-offer-card-img-radius" src={CONFIG.cloudFront + headerBannerImg} alt="" />
                </DynamicPrimeOfferImgWrapper>
              ) : (
                <Fragment>
                  {variant === 'originals' ? (
                    <DboardPrimeOfferSvg data={CONFIG.cloudFront + '/Assets/GiftBurst.svg'}>offer Icon</DboardPrimeOfferSvg>
                  ) : (
                    <DboardPrimeOfferSvg data={CONFIG.cloudFront + '/Assets/GiftBurstwhite.svg'}>offer Icon</DboardPrimeOfferSvg>
                  )}
                </Fragment>
              )}
            </div>
            <DboardPrimeOfferContentWrapper>
              <p
                className={`font-size-inherit ${variant === 'code-juniors' ? 'dynamic-offer-yellow-color' : 'dynamic-offer-yellow-highlight'}`}
                dangerouslySetInnerHTML={{ __html: headerOfferDescription }}
              ></p>

              <div className="d-md-flex align-items-center justify-content-between pt-md-3 d-xl-none">
                <PrimeOfferTimerDiv>
                  <PrimeOffer
                    type={'dboard-prime-bar'}
                    variant={variant}
                    isNoMargin={true}
                    noMarginTop={true}
                    minimalGap={true}
                    numDays={headerOfferDayCount}
                    offerEndTime={headerOfferEndTime}
                  />
                </PrimeOfferTimerDiv>

                <div className="pt-3 pt-md-0 pl-md-3">
                  <DboardPrimeOfferButton variant={variant === 'regionals' ? 'light' : ''}>Buy now ➜</DboardPrimeOfferButton>
                </div>
              </div>
            </DboardPrimeOfferContentWrapper>

            <div className="d-none d-xl-block pl-3">
              <DboardPrimeOfferButton variant={variant === 'regionals' ? 'light' : ''}>Buy now ➜</DboardPrimeOfferButton>
            </div>
          </DynamicPrimeOfferCardBody>
        </DboardPrimeRightWrapper>
      </Fragment>
    );
  };

  return (
    <DboardPrimeOfferCardOuter>
      {content === 'originals-prime' ? (
        <DboardPrimeOfferCardInner variant={variant} darkTheme={darkTheme} isDynamic={headerBannerImg ? 'true' : 'false'} onClick={() => history.push(navigateLink)}>
          {_renderContent()}
        </DboardPrimeOfferCardInner>
      ) : null}

      {content === 'partner-prime' ? (
        <Fragment>
          <DboardPrimeOfferCardInner variant={variant} darkTheme={darkTheme} isDynamic={headerBannerImg ? 'true' : 'false'} onClick={() => history.push(navigateLink)}>
            {_renderContent()}
          </DboardPrimeOfferCardInner>
        </Fragment>
      ) : null}

      {content === 'partner-package' ? (
        <Fragment>
          <DboardPrimeOfferCardLabel>{courseCategory} Combo</DboardPrimeOfferCardLabel>
          <DboardPrimeOfferCardInner
            variant={variant}
            darkTheme={darkTheme}
            isDynamic={headerBannerImg ? 'true' : 'false'}
            onClick={() => history.push(partnerPackageNavigateLink)}
          >
            {_renderContent()}
          </DboardPrimeOfferCardInner>
        </Fragment>
      ) : null}

      {content === 'regionals-prime' ? (
        <Fragment>
          {/*<DboardPrimeOfferCardLabel>
            { language === 'tamil ?
              <Fragment>
                <span className="font-size-inherit weight-600">{coursesLanguage}</span> Prime Membership
              </Fragment>
              ) : (
                <Fragment>
                  <span className="font-size-inherit weight-600">{coursesLanguage}</span> Combo
                </Fragment>
            }
          </DboardPrimeOfferCardLabel>*/}
          <DboardPrimeOfferCardInner variant={variant} darkTheme={darkTheme} isDynamic={headerBannerImg ? 'true' : 'false'} onClick={() => history.push(navigateLink)}>
            {_renderContent()}
          </DboardPrimeOfferCardInner>
        </Fragment>
      ) : null}

      {content === 'regionals-expert' ? (
        <Fragment>
          <DboardPrimeOfferCardLabel>
            <span className="font-size-inherit weight-600">{coursesLanguage}</span> {courseCategory} Combo
          </DboardPrimeOfferCardLabel>
          <DboardPrimeOfferCardInner
            variant={variant}
            darkTheme={darkTheme}
            isDynamic={headerBannerImg ? 'true' : 'false'}
            onClick={() => history.push(regionalsExpertNavigateLink)}
          >
            {_renderContent()}
          </DboardPrimeOfferCardInner>
        </Fragment>
      ) : null}

      {content === 'regionals-animation' ? (
        <Fragment>
          <DboardPrimeOfferCardLabel>
            <span className="font-size-inherit weight-600">{coursesLanguage}</span> {language === 'tamil' ? courseCategory : null} Combo
          </DboardPrimeOfferCardLabel>
          <DboardPrimeOfferCardInner
            variant={variant}
            darkTheme={darkTheme}
            isDynamic={headerBannerImg ? 'true' : 'false'}
            onClick={() => {
              if (language === 'tamil') history.push(regionalsAnimationNavigateLink);
              else history.push(regionalsNavigateLink);
            }}
          >
            {_renderContent()}
          </DboardPrimeOfferCardInner>
        </Fragment>
      ) : null}

      {content === 'juniors-prime' ? (
        <Fragment>
          <DboardPrimeOfferCardInner variant={variant} darkTheme={darkTheme} isDynamic={headerBannerImg ? 'true' : 'false'} onClick={() => history.push(navigateLink)}>
            {_renderContent()}
          </DboardPrimeOfferCardInner>
        </Fragment>
      ) : null}
    </DboardPrimeOfferCardOuter>
  );
};

const InfoBar = ({
  isOnlyForAbroad,
  checkout,
  handlePromocodePricing,
  status,
  loading,
  infoBarMessage,
  differentCostPath,
  type,
  history,
  handleInfoBar,
  courseName,
  country,
  handleAllAccessClick,
  specialPrice,
  handleCourseAccess,
  isFromDSA,
  offerPrice,
  oldPrice,
  trialSnackbar,
  countryName,
  headerOfferLink,
  headerOfferName,
  headerOfferPercent,
  headerOfferPath,
  headerOfferDayCount,
  headerOfferImg,
  headerBannerImg,
  headerOfferTitle,
  headerOfferDescription,
  headerOfferPercentage,
  headerOfferEndTime,
  language,
  coursesLanguage,
  courseCategory,
  content,
  packageOfferLinkPrefix,
  nonRecurrentBar,
  variant,
  darkTheme,
}) => (
  <Fragment>
    {type === 'studentOffer' && <StudentOfferInfo history={history} handleInfoBar={handleInfoBar} />}
    {type === 'newCourse' && <NewCourseLaunchInfo history={history} handleInfoBar={handleInfoBar} />}
    {type === 'courseOffer' && (
      <CourseOfferInfo handleInfoBar={handleInfoBar} courseName={courseName} specialPrice={specialPrice} handleCourseAccess={handleCourseAccess} isFromDSA={isFromDSA} />
    )}
    {type === 'countryOfferBar' && (
      <CountrySpecificPricingInfo trialSnackbar={trialSnackbar} headerOfferLink={headerOfferLink} countryName={countryName} handleInfoBar={handleInfoBar} />
    )}
    {type === 'promoCode' && (
      <PromoCodeInfo
        isOnlyForAbroad={isOnlyForAbroad}
        differentCostPath={differentCostPath}
        infoBarMessage={infoBarMessage}
        status={status}
        country={country}
        handleInfoBar={handleInfoBar}
        checkout={checkout}
        handlePromocodePricing={handlePromocodePricing}
        handleAllAccessClick={handleAllAccessClick}
        loading={loading}
      />
    )}
    {type === 'staticInfo' && <StaticInfo content={content} />}
    {type === 'specialOff' && <SpecialOfferBar trialSnackbar={trialSnackbar} country={country} handleInfoBar={handleInfoBar} />}
    {type === 'confettiHeader' && <ConfettiHeaderBar content={content} trialSnackbar={trialSnackbar} handleInfoBar={handleInfoBar} />}
    {type === 'oneTimeOffer' && <OneTimeOffer country={country} headerOfferLink={headerOfferLink} />}
    {type === 'confettiOff' && (
      <ConfettiInfo
        content={content}
        variant={variant}
        darkTheme={darkTheme}
        headerOfferLink={headerOfferLink}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferImg={headerOfferImg}
        language={language}
        coursesLanguage={coursesLanguage}
        offerPrice={offerPrice}
      />
    )}
    {/* currently used infobars */}
    {type === 'originalsTopBar' && (
      <OriginalsTopOfferBar
        country={country}
        trialSnackbar={trialSnackbar}
        nonRecurrentBar={nonRecurrentBar}
        headerOfferLink={headerOfferLink}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferPercent={headerOfferPercent}
        headerOfferTitle={headerOfferTitle}
        headerOfferImg={headerOfferImg}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferEndTime={headerOfferEndTime}
        handleInfoBar={handleInfoBar}
      />
    )}
    {type === 'originalsBottomBar' && (
      <OriginalsBottomOfferBar
        history={history}
        nonRecurrentBar={nonRecurrentBar}
        headerOfferLink={headerOfferLink}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferPercent={headerOfferPercent}
        headerOfferTitle={headerOfferTitle}
        headerOfferImg={headerOfferImg}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferEndTime={headerOfferEndTime}
        handleInfoBar={handleInfoBar}
      />
    )}
    {type === 'partnerPlusOff' && (
      <PartnerPlusOffer
        trialSnackbar={trialSnackbar}
        handleInfoBar={handleInfoBar}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferLink={headerOfferLink}
        nonRecurrentBar={nonRecurrentBar}
        headerOfferPercent={headerOfferPercent}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferImg={headerOfferImg}
        headerOfferTitle={headerOfferTitle}
        headerOfferEndTime={headerOfferEndTime}
      />
    )}
    {type === 'partnerPlusBottomOff' && (
      <PartnerPlusBottomOffer
        handleInfoBar={handleInfoBar}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferLink={headerOfferLink}
        headerOfferPercent={headerOfferPercent}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferImg={headerOfferImg}
        nonRecurrentBar={nonRecurrentBar}
        headerOfferTitle={headerOfferTitle}
        headerOfferEndTime={headerOfferEndTime}
      />
    )}
    {type === 'packageOff' && (
      <PackageOffer
        trialSnackbar={trialSnackbar}
        handleInfoBar={handleInfoBar}
        country={country}
        offerPrice={offerPrice}
        oldPrice={oldPrice}
        courseName={courseName}
        packageOfferLinkPrefix={packageOfferLinkPrefix}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferLink={headerOfferLink}
        headerOfferPercent={headerOfferPercent}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferImg={headerOfferImg}
        headerOfferTitle={headerOfferTitle}
        headerOfferEndTime={headerOfferEndTime}
      />
    )}
    {type === 'regionalsOfferInfo' && (
      <RegionalsOfferInfo
        country={country}
        trialSnackbar={trialSnackbar}
        handleInfoBar={handleInfoBar}
        language={language}
        coursesLanguage={coursesLanguage}
        courseCategory={courseCategory}
        courseName={courseName}
        specialPrice={specialPrice}
        offerPrice={offerPrice}
        oldPrice={oldPrice}
        handleCourseAccess={handleCourseAccess}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferLink={headerOfferLink}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferPercent={headerOfferPercent}
        headerOfferImg={headerOfferImg}
        nonRecurrentBar={nonRecurrentBar}
        headerOfferTitle={headerOfferTitle}
        headerOfferEndTime={headerOfferEndTime}
      />
    )}
    {type === 'regionalsBottomOffer' && (
      <RegionalsBottomOffer
        country={country}
        handleInfoBar={handleInfoBar}
        language={language}
        coursesLanguage={coursesLanguage}
        offerPrice={offerPrice}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferLink={headerOfferLink}
        headerOfferPercent={headerOfferPercent}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferImg={headerOfferImg}
        nonRecurrentBar={nonRecurrentBar}
        headerOfferTitle={headerOfferTitle}
        headerOfferEndTime={headerOfferEndTime}
      />
    )}
    {type === 'regionalPackageOff' && (
      <RegionalPackageOffer
        trialSnackbar={trialSnackbar}
        handleInfoBar={handleInfoBar}
        country={country}
        offerPrice={offerPrice}
        oldPrice={oldPrice}
        language={language}
        coursesLanguage={coursesLanguage}
        courseName={courseName}
        packageOfferLinkPrefix={packageOfferLinkPrefix}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferLink={headerOfferLink}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferPercent={headerOfferPercent}
        headerOfferImg={headerOfferImg}
        headerOfferTitle={headerOfferTitle}
        headerOfferEndTime={headerOfferEndTime}
      />
    )}
    {type === 'codeJuniorsOff' && (
      <CodeJuniorsOffer
        trialSnackbar={trialSnackbar}
        handleInfoBar={handleInfoBar}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferLink={headerOfferLink}
        headerOfferPercent={headerOfferPercent}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferImg={headerOfferImg}
        nonRecurrentBar={nonRecurrentBar}
        headerOfferTitle={headerOfferTitle}
        headerOfferEndTime={headerOfferEndTime}
      />
    )}
    {type === 'codeJuniorsBottomOff' && (
      <CodeJuniorsBottomOffer
        handleInfoBar={handleInfoBar}
        headerOfferName={headerOfferName}
        headerOfferPath={headerOfferPath}
        headerOfferLink={headerOfferLink}
        headerOfferPercent={headerOfferPercent}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferImg={headerOfferImg}
        nonRecurrentBar={nonRecurrentBar}
        headerOfferTitle={headerOfferTitle}
        headerOfferEndTime={headerOfferEndTime}
      />
    )}
    {type === 'dboardDynamicPrime' && (
      <DboardDynamicPrimeBar
        content={content}
        variant={variant}
        darkTheme={darkTheme}
        history={history}
        headerOfferLink={headerOfferLink}
        headerOfferDayCount={headerOfferDayCount}
        headerOfferImg={headerOfferImg}
        headerBannerImg={headerBannerImg}
        headerOfferTitle={headerOfferTitle}
        headerOfferDescription={headerOfferDescription}
        headerOfferPercentage={headerOfferPercentage}
        headerOfferEndTime={headerOfferEndTime}
        language={language}
        coursesLanguage={coursesLanguage}
        courseCategory={courseCategory}
      />
    )}
  </Fragment>
);

export default InfoBar;
